import React from "react";
import Modal from "../Modal";
import styled from "styled-components";
import BizButton from "./Button";
import { Colors } from "../../config";

const ConfirmPopup = ({
  onClose,
  onConfirm,
  perDiemPopup,
  timeModal,
}) => {
  return (
    <Modal setClose={onClose}>
      <StyledBox>
        <img
          src={require("../../assets/images/confirm.png")}
          style={{ width: "48px", height: "48px", marginBottom: "0.5rem" }}
        />
        <Title>Proceed With These Trip Details?</Title>
        <Content>
          {timeModal && (
            <Description>
              Departure & return are on the same date. Continue booking?
            </Description>
          )}
          {perDiemPopup && (
            <Description>
              No per diem selected. Continue without a per diem for this trip?
            </Description>
          )}
        </Content>
        <ButtonRow>
          <BizButton
            isRounded
            onClick={onClose}
            label="Cancel"
            color={Colors.brandOne}
            isOutlined
            width="50%"
            size="sm"
          />
          <BizButton
            isRounded
            onClick={onConfirm}
            label="Confirm"
            color={Colors.brandOne}
            width="50%"
            size="md"
          />
        </ButtonRow>
      </StyledBox>
    </Modal>
  );
};

const StyledBox = styled.div`
  padding: 1.5rem 1rem;
  display: flex;
  // gap: 1rem;
  max-width: 350px;
  text-align: center;
  flex-direction: column;
  text-align: left;
  @media only screen and (max-width: 768px) {
    width: 300px;
  }
`;

const Title = styled.div`
  font-size: 1.1rem;
  color: ${Colors.brandOne};
  // font-weight: bold;
`;

const Content = styled.ul`
  color: ${Colors.coolGrey};
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-left: 1rem;
  margin-bottom: 2rem;
`;

const Description = styled.li`
  font-size: 0.9rem;
`;

const List = styled.div`
  color: ${Colors.brandOne};
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  text-align: left;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export default ConfirmPopup;
